<section
  class="zag-accordion-item"
  [class.zag-accordion-item--expanded]="expanded()"
  [class.zag-accordion-item--disabled]="disabled()"
  [class.zag-accordion-item--flat]="flat()"
  [class.zag-accordion-item--collection-header]="headerVariant() === 'collection'"
  [class.zag-accordion-item--stacked-header]="headerVariant() === 'stacked'"
  [zagScrollIntoView]="!disableAutoScroll()"
  [scrollOnSignal]="expanded"
  [scrollEvents]="[]"
  [scrollDelay]="100"
  scrollBlock="start"
>
  @if (!flat()) {
  <ng-template #headerActions>
    <span class="zag-accordion-item__actions">
      <ng-content select="[slot=actions]" />
    </span>
  </ng-template>
  <div
    class="zag-accordion-item__toggle"
    role="button"
    [attr.tabindex]="disabled() ? -1 : 0"
    (click)="toggle($event)"
    (keydown.enter)="handleToggleKey($event)"
    (keydown.space)="handleToggleKey($event)"
    [attr.aria-expanded]="expanded()"
    [attr.aria-controls]="expanded() ? contentId : null"
    [attr.aria-disabled]="disabled() ? true : null"
  >
    <span class="zag-accordion-item__icon zag-accordion-item__icon--slot">
      <ng-content select="[slot=icon]" />
    </span>
    @if (icon()) {
    <span [zagIcon]="icon()!" class="zag-accordion-item__icon zag-accordion-item__icon--material"></span>
    } @if (subtitle()) {
    <span class="zag-accordion-item__heading">
      <span class="zag-accordion-item__title">{{ title() }}</span>
      <span class="zag-accordion-item__subtitle">{{ subtitle() }}</span>
    </span>
    } @else {
    <span class="zag-accordion-item__title">{{ title() }}</span>
    }
    <span class="zag-accordion-item__title-actions">
      <ng-content select="[slot=title-actions]" />
    </span>
    <span class="zag-accordion-item__meta"><ng-content select="[slot=meta]" /></span>
    @if (badge() !== null) {
    <span class="zag-accordion-item__badge">{{ badge() }}</span>
    } @if (statusIcon()) {
    <span
      [zagIcon]="statusIcon()!"
      [zagTooltip]="statusTooltip()"
      tooltipPosition="above"
      role="img"
      [attr.aria-label]="statusTooltip()"
      class="zag-accordion-item__status-icon"
      [class.zag-accordion-item__status-icon--warning]="statusVariant() === 'warning'"
    ></span>
    } @if (headerVariant() !== 'stacked') {
    <ng-container [ngTemplateOutlet]="headerActions" />
    }
    <span zagIcon="expand_more" class="zag-accordion-item__chevron" [class.zag-accordion-item__chevron--expanded]="expanded()"></span>
  </div>
  @if (headerVariant() === 'stacked') {
  <ng-container [ngTemplateOutlet]="headerActions" />
  } } @if (expanded() || flat()) {
  <div [id]="contentId" class="zag-accordion-item__content">
    <ng-content />
  </div>
  }
</section>
